"use strict";

var AbstractApi = require("./AbstractApi");

var PlaidApi = class extends AbstractApi {
	// Call made to SO API
	generatePlaidLinkToken() {
		return this.post({
			url: "/api/plaid/create-link-token"
		});
	}

	getEftAccountData(publicToken, accounts) {
		return this.post({
			url: "/api/plaid/get-eft-account-data",
			data: {
				publicToken,
				accounts
			}
		});
	}
};

module.exports = new PlaidApi();
